import { useContext, useEffect, useState } from 'react';
import {
  Wizard,
  Layout,
  Fieldset,
  Heading,
  FormField,
  FormFieldRadioButtonGroup,
  RadioButton,
  ButtonContainer,
  Button,
} from '@vwfs-bronson/bronson-react';
import { useDispatch } from 'react-redux';
import { setSelectedSeguroAutoStandAlone } from '../../../actions/summaryAction';
import Notification, { SEVERITY_NOTIFICACION, TYPE_NOTIFICACION } from '../../../class/Notification';
import { addNotification } from '../../../actions/notificationAction';
import { GetTarificacionZurichLongDrive, setSeguroStandAlone } from '../../../actions/insuranceAction';
import { useInsurance } from '../../../hooks/useInsurance';
import { Coberturas } from './Coberturas/Coberturas';
import { WizardConext } from '../../../contexts/WizardContext';
import { FormInfo } from './ClientInfoStep/FormInfo';
import { isInfoValid } from './ClientInfoStep/ValidateInfo';

export const SeguroAutomovilStandAlone = () => {
  const dispatch = useDispatch();
  const { tarifasZurich } = useInsurance();
  const { SeguroAutoActions } = useContext(WizardConext);
  const [stepSelected, setStepSelected] = useState('DatosClientes');

  const buildSeguroStandAlone = () => {
    const conductorHabitualValues = SeguroAutoActions.conductorHabitual
      ? SeguroAutoActions.formValuesTomador
      : SeguroAutoActions.formValuesConductorHabitual;

    const conductorOcasionalValues = SeguroAutoActions.conductorOcasional
      ? SeguroAutoActions.formValuesConductorOcasional
      : null;

    return setSeguroStandAlone(
      SeguroAutoActions.formValuesTomador,
      conductorHabitualValues,
      conductorOcasionalValues,
      SeguroAutoActions.Cobertura,
    );
  };

  useEffect(() => {
    SeguroAutoActions.setCobertura(null);
  }, []);

  useEffect(() => {
    dispatch(setSelectedSeguroAutoStandAlone(buildSeguroStandAlone()));
  }, [SeguroAutoActions.Cobertura]);

  const handleNext = () => {
    const tomadorIsValid = isInfoValid(SeguroAutoActions.formValuesTomador, 'tomador');

    const conductorHabitualIsValid =
      SeguroAutoActions.conductorHabitual ||
      isInfoValid(SeguroAutoActions.formValuesConductorHabitual, 'conductorHabitual');

    const conductorOcasionalIsValid =
      !SeguroAutoActions.conductorOcasional ||
      isInfoValid(SeguroAutoActions.formValuesConductorOcasional, 'conductorOcasional');

    if (!tomadorIsValid || !conductorHabitualIsValid || !conductorOcasionalIsValid) {
      const notification = new Notification.fromObject({
        Description: 'Los datos marcados en rojo son incorrectos.',
        Timeout: 3000,
        Type: TYPE_NOTIFICACION.TOAST,
        Severity: SEVERITY_NOTIFICACION.ERROR,
      });
      dispatch(addNotification(notification));
      return;
    }

    const seguroStandAlone = buildSeguroStandAlone();

    dispatch(setSelectedSeguroAutoStandAlone(seguroStandAlone));
    dispatch(GetTarificacionZurichLongDrive());
    setStepSelected('Coberturas');
  };

  const handleBack = () => {
    dispatch(setSelectedSeguroAutoStandAlone(buildSeguroStandAlone()));

    setStepSelected('DatosClientes');
  };

  return (
    <>
      <Wizard
        collapseBreakpoint="s"
        collapsedCounter="1/2"
        collapsedText="Current Step"
        noInteraction
        stepLabels={{
          doneLabel: 'Done',
          notDoneLabel: 'Not done',
          errorLabel: 'Error',
          noInteractionLabel: 'Step',
        }}
      >
        {stepSelected === 'DatosClientes' ? (
          <>
            <Wizard.Item key="step_datos_cliente" active>
              Datos Cliente
            </Wizard.Item>
            <Wizard.Item key="step_coberturas">Selección Coberturas</Wizard.Item>
          </>
        ) : (
          <>
            <Wizard.Item key="step_datos_cliente" done>
              Datos Cliente
            </Wizard.Item>
            <Wizard.Item key="step_coberturas" active>
              Selección Coberturas
            </Wizard.Item>
          </>
        )}
      </Wizard>
      <Layout.Item>
        <ButtonContainer>
          {stepSelected === 'Coberturas' && (
            <Button onClick={() => handleBack()} link small icon="semantic-back">
              Editar datos cliente
            </Button>
          )}
        </ButtonContainer>
      </Layout.Item>
      {stepSelected === 'DatosClientes' && (
        <Layout.Item>
          <>
            <Fieldset.Row>
              <Heading level={6}>Datos tomador/pagador</Heading>
              <FormInfo
                formValues={SeguroAutoActions.formValuesTomador}
                handleOnChange={SeguroAutoActions.setHandleOnChangeTomador}
                setValues={SeguroAutoActions.setValuesTomador}
                formType="tomador"
                layoutSize="1/4"
              />
              <Fieldset.Row className=" u-mb-none">
                <Layout className="u-mt-xsmall">
                  <Layout.Item default="2/3">
                    <Heading level={6} className="u-text-left">
                      ¿Es el tomador/pagador el conductor habitual?
                    </Heading>
                  </Layout.Item>
                  <Layout.Item default="1/3" xs="1/1">
                    <FormField labelElement="div" staticLabel type="other">
                      <FormFieldRadioButtonGroup className="u-float-right">
                        <RadioButton
                          checked={SeguroAutoActions.conductorHabitual}
                          name="ConductorHabitual"
                          onChange={() => SeguroAutoActions.setConductorHabitual(true)}
                        >
                          Sí
                        </RadioButton>
                        <RadioButton
                          checked={!SeguroAutoActions.conductorHabitual}
                          name="ConductorHabitual"
                          onChange={() => SeguroAutoActions.setConductorHabitual(false)}
                        >
                          No
                        </RadioButton>
                      </FormFieldRadioButtonGroup>
                    </FormField>
                  </Layout.Item>
                </Layout>
              </Fieldset.Row>
              {!SeguroAutoActions.conductorHabitual && (
                <div className="u-mb-xlarge">
                  <Heading level={6}>Datos conductor habitual</Heading>
                  <FormInfo
                    formValues={SeguroAutoActions.formValuesConductorHabitual}
                    handleOnChange={SeguroAutoActions.setHandleOnChangeConductorHabitual}
                    setValues={SeguroAutoActions.setValuesConductorHabitual}
                    formType="conductorHabitual"
                    layoutSize="1/3"
                  />
                </div>
              )}
              <Fieldset.Row className=" u-mb-none">
                <Layout>
                  <Layout.Item default="2/3">
                    <Heading level={6} className="u-text-left">
                      ¿Hay un conductor ocasional?
                    </Heading>
                  </Layout.Item>
                  <Layout.Item default="1/3" xs="1/1">
                    <FormField labelElement="div" staticLabel type="other">
                      <FormFieldRadioButtonGroup className="u-float-right">
                        <RadioButton
                          checked={SeguroAutoActions.conductorOcasional}
                          name="ConductorOcasional"
                          onChange={() => SeguroAutoActions.setConductorOcasional(true)}
                        >
                          Sí
                        </RadioButton>
                        <RadioButton
                          checked={!SeguroAutoActions.conductorOcasional}
                          name="ConductorOcasional"
                          onChange={() => SeguroAutoActions.setConductorOcasional(false)}
                        >
                          No
                        </RadioButton>
                      </FormFieldRadioButtonGroup>
                    </FormField>
                  </Layout.Item>
                </Layout>
              </Fieldset.Row>
              {SeguroAutoActions.conductorOcasional && (
                <>
                  <Heading level={6}>Datos conductor ocasional</Heading>
                  <FormInfo
                    formValues={SeguroAutoActions.formValuesConductorOcasional}
                    handleOnChange={SeguroAutoActions.setHandleOnChangeConductorOcasional}
                    setValues={SeguroAutoActions.setValuesCondutorOcasional}
                    formType="conductorOcasional"
                    layoutSize="1/3"
                  />
                </>
              )}
            </Fieldset.Row>
          </>
        </Layout.Item>
      )}
      {stepSelected === 'Coberturas' && (
        <Coberturas tarifasZurich={tarifasZurich} setCobertura={SeguroAutoActions.setCobertura}></Coberturas>
      )}
      <Layout.Item>
        <div className="u-text-center">
          {stepSelected === 'DatosClientes' && <Button onClick={() => handleNext()}> Siguiente </Button>}
        </div>
      </Layout.Item>
    </>
  );
};
